import { filter } from "~/tools/filter";
import { identity } from "~/tools/identity";
import { isPresent } from "~/tools/is-present";
import { meanBy } from "~/tools/mean-by";
import { pipe } from "~/tools/pipe";

export function mean(values: ReadonlyArray<null | undefined | number>): undefined | number {
	const result = pipe(values, filter(isPresent), meanBy(identity));

	return isNaN(result) ? undefined : result;
}
